import React from 'react'
import { InformationalDialog } from '@jarvis.oddle/core/components/Dialog'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'
import { makeControlledModal } from 'src/decorators/ModalController'

const ErrorModal = ({
  modal,
  error,
  ...props
}: {
  modal: {
    show: boolean
    onClose: (handler?) => void
    onClosed: () => void
  }
  error
}): JSX.Element => {
  const { t } = React.useContext(TranslationContext)

  return (
    <InformationalDialog
      {...props}
      {...modal}
      header={t('Oops')}
      body={error} />
  )
}

export default makeControlledModal(ErrorModal, 'ErrorModal')
